module.exports = __webpack_public_path__ + "img/icon-issue-end.047658c1.svg";